import { client } from './client'
import type { components } from './auto-gen-types'

export type CreateDesktopHandoffRequest = components['schemas']['CreateDesktopHandoffRequest']
export type DesktopHandoff = components['schemas']['DesktopHandoffResponse']

export const AuthAPI = {
  // 返る code は一度だけ使える資格情報。ログや永続化をしない（openapi.yaml の DesktopHandoffResponse.code）
  createDesktopHandoff: (body: CreateDesktopHandoffRequest) => client.POST('/auth/desktop-handoff', {body}),
}
